import React from 'react';
import { FontIcon } from 'react-toolbox/lib/font_icon';
import styles from 'components/SeeMoreListItemsButton.css';

const SeeMoreListItemsButton = ({ onClick }) =>
  <div className={styles.seeMore} onClick={onClick}>
    See more <FontIcon className={styles.seeMoreIcon} value="expand_more" />
  </div>;
export default SeeMoreListItemsButton;
